<!--    @reset="showTree?$refs.treeSelect.clearHandle():null" -->
<template>
  <div>
    <div class="query"><label>考勤对象人群</label>
      <el-input type="text" placeholder="请输入考勤对象人群" style="width:200px" clearable />
    </div>
    <div class="border people">
      <el-button type="primary">添加</el-button>
      <el-table :data="api.list" border>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="DpNmae" label="类型" :width="80" align="center"></el-table-column>
        <el-table-column label="操作" :width="60" align="center">
          <template slot-scope="{row}">
            <el-button type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <list row-key="CarId" ref="list" unit="考勤设备选择" :expand-all-row="true" :page="true" :query-params="params"
      :show-checkbox="showCheckbox && $permission.canWrite()" :show-query="showQuery" :get-data-func="api.list">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="人员编号">
          <el-input type="text" v-model="params.No" placeholder="请输入事件名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="人员编号">
          <el-input type="text" v-model="params.name" placeholder="请输入考勤对象" clearable></el-input>
        </el-form-item>
        <el-form-item label="人员类型">
          <el-select v-model="params.type" clearable="">
            <el-option :value="0" label="学生"></el-option>
            <el-option :value="1" label="教职人员"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.grade" clearable="">
            <el-option :value="0" label="年级1"></el-option>
            <el-option :value="1" label="年级2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.class" clearable="">
            <el-option :value="0" label="班级1"></el-option>
            <el-option :value="1" label="班级2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="params.dp" clearable="">
            <el-option :value="0" label="部门0"></el-option>
            <el-option :value="1" label="部门1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SectionNumber" :width="isMB ? 60 : 80" label="人员编号" />
        <el-table-column prop="Grade" :width="240" label="人员姓名" />
        <el-table-column prop="SectionName" label="年级" :width="140" />
        <el-table-column prop="EndTime" :min-width="isMB ? 120 : ''" label="班级" />
        <el-table-column prop="EndTime" :min-width="isMB ? 120 : ''" label="部门" />
        <el-table-column prop="EndTime" :min-width="isMB ? 120 : ''" label="人员类型" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import list from "@/components/common/list";


export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showTree: {
      type: Boolean,
      default: true
    },
    showRecord: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      api: require("@/api/ed/section").default,
      params: {
        name: "",
        No: "",
        type: null,
        grade: null,
        class: null,
        dp: null
      },
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {

  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.query {
  label {
    margin-right: 10px;
  }
}

.people {
  margin: 10px 0;
  padding: 10px;

  button {
    margin-bottom: 10px;
  }
}
</style>